<template>
    <div>
        <InfoPageBlock
            h1="Haven't used your trademark in interstate commerce? No problem. Extend."
            stepsLength="7"
            url="/statement-of-use-extension/confirm"
        ></InfoPageBlock>
    </div>
</template>

<script>
import InfoPageBlock from '@/components/blocks/InfoPageBlock.vue'
import {to_top} from "@/helper";

export default {
    components: {
        InfoPageBlock
    },
    mounted() {
        to_top()
        this.$store.commit('header/setTotal', 0)
    }
}
</script>
